
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#FFF","width":"28","height":"28","rx":"8"}}),_c('path',{attrs:{"d":"M7.836 11.244c0-.243.086-.448.258-.615a.86.86 0 01.622-.252h.881v3.928h-.88a.86.86 0 01-.623-.252.825.825 0 01-.258-.615v-2.194zm9.784-3.607c.4-.382.764-.591 1.09-.629.327-.037.615.05.867.259.252.21.466.517.643.923.177.405.321.857.433 1.355.112.499.196 1.02.252 1.566.056.545.084 1.064.084 1.558s-.035.988-.105 1.482c-.07.494-.172.957-.308 1.39a6.023 6.023 0 01-.475 1.14c-.182.326-.384.568-.608.727a.918.918 0 01-.72.167c-.256-.046-.524-.228-.803-.545-.27-.316-.636-.58-1.098-.79a9.56 9.56 0 00-1.51-.53 16.597 16.597 0 00-1.656-.35c-.559-.088-1.071-.168-1.537-.238-.466-.07-.855-.137-1.167-.202-.312-.065-.487-.145-.524-.238v-4.375c.037-.13.184-.237.44-.321.256-.084.582-.163.978-.238.396-.074.844-.156 1.342-.245.499-.088 1.007-.21 1.524-.363.517-.154 1.022-.35 1.516-.587a5.39 5.39 0 001.342-.916zm-5.032 8.569c.047.112.103.233.168.363.056.121.13.261.224.42.093.158.205.33.335.517.159.223.32.459.482.705.163.247.287.471.37.671.085.2.11.366.078.497-.033.13-.166.195-.399.195h-.796c-.187 0-.36-.035-.518-.105a1.508 1.508 0 01-.454-.321 3.938 3.938 0 01-.447-.552c-.154-.224-.32-.49-.496-.797a4.451 4.451 0 01-.448-.93 4.756 4.756 0 01-.167-.663 1.268 1.268 0 010-.531c.074.009.163.027.265.055l.308.07c.12.028.26.056.419.084.158.037.3.072.426.105s.24.068.343.105c.112.037.214.074.307.112z","fill":"#8D9EC0","fill-rule":"nonzero"}})])])
          )
        }
      }
    